import { useStore } from "../../stores/StoreContext";
import { SettingsService } from "../LogicServices/SettingsService";

export function useSettingService(): SettingsService {
  const storeContext = useStore();
  return new SettingsService(storeContext);
}
